var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignOutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.497,
    height: 19.997,
    viewBox: "0 0 24.497 19.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,59.613a.407.407,0,0,1-.031-.211c.011-.057-.026-.1-.109-.14s-.125-.065-.125-.086-.06-.037-.18-.047l-.18-.016H4.5a2.406,2.406,0,0,1-1.766-.734A2.407,2.407,0,0,1,2,56.613v-11a2.407,2.407,0,0,1,.734-1.765A2.407,2.407,0,0,1,4.5,43.114h5a.472.472,0,0,0,.32-.1.519.519,0,0,0,.156-.3,2.629,2.629,0,0,0,.047-.367,3.887,3.887,0,0,0-.008-.414Q10,41.677,10,41.615a.507.507,0,0,0-.5-.5h-5a4.334,4.334,0,0,0-3.179,1.32A4.334,4.334,0,0,0,0,45.614v11a4.333,4.333,0,0,0,1.32,3.179A4.333,4.333,0,0,0,4.5,61.112h5a.474.474,0,0,0,.32-.1.519.519,0,0,0,.156-.3,2.634,2.634,0,0,0,.047-.367,3.883,3.883,0,0,0-.008-.414Q10,59.675,10,59.613Z",
    transform: "translate(0 -41.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M127.834,59.042l-8.5-8.5a1,1,0,0,0-1.7.7v4.5h-7a1.014,1.014,0,0,0-1,1v6a1.014,1.014,0,0,0,1,1h7v4.5a.994.994,0,0,0,1.7.7l8.5-8.5a.981.981,0,0,0,0-1.406Z",
    transform: "translate(-103.634 -49.746)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/sign-out-icon.40e3c98c.svg";
export { ForwardRef as ReactComponent };